import React from "react";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectCoverflow, Navigation } from "swiper/modules";
import { Link } from "react-router-dom"; // <-- import Link
import "swiper/css";
import "swiper/css/effect-coverflow";

// Images
import slide1 from "../images/led2.jpg";
import slide2 from "../images/downlight.jpg";
import slide3 from "../images/panel-light.jpg";
import slide4 from "../images/adju.jpeg";
import slide5 from "../images/8.jpg";
import slide6 from "../images/cob.jpeg";
import slide7 from "../images/batn.jpeg";

// Slides with IDs for routing
const slides = [
  { id: 2, img: slide1, title: "Led Bulb" },
  { id: 3, img: slide2, title: "Downlights" },
  { id: 4, img: slide3, title: "Panel Lights" },
  { id: 5, img: slide4, title: "Adjustable Panel Lights" },
  { id: 15, img: slide5, title: "Spot Lights" },
  { id: 7, img: slide6, title: "LED COB" },
  { id: 8, img: slide7, title: "Batten Light" },
];

const AutoSlider = () => {
  return (
    <Container fluid className="mySwiperContainer">
      <Swiper
        effect="coverflow"
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        loop={true}
        autoplay={{
          delay: 1500,
          disableOnInteraction: false,
        }}
        navigation={true}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 200,
          modifier: 2.5,
          slideShadows: false,
        }}
        speed={600}
        modules={[Autoplay, EffectCoverflow, Navigation]}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <Link
              to={`/ProductList/${slide.id}`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img src={slide.img} alt={slide.title} />
              <div className="slideTitle">
              <h2 style={{  textAlign: 'center' }}>{slide.title}</h2>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </Container>
  );
};

export default AutoSlider;
